import ClaritasService from "./ClaritasService";
import { getProductPurchaseModel } from "./SubscriptionService";
import { analytics, logEvent, setUserId } from "../lib/firebase";
import { hashString } from "./hash";
import { capturePostHogEvent, identifyPostHogUser } from "./PostHogService";

const disableAnalytics = process.env.NEXT_PUBLIC_DISABLE_ANALYTICS === "true";

export default {
  track: (eventName: string, properties: any) => {
    if (disableAnalytics) {
      console.debug(`[Analytics] track "${eventName}"`, properties);
      return;
    }

    // Web vitals are just for performance monitoring
    if (eventName.startsWith("Next.js")) {
      return;
    }

    try {
      // Firebase
      logEvent(analytics, eventName.toLowerCase().replace(/-/g, "").replace(/ /g, "_"), properties);

      // Purchase Success
      if (eventName === "Purchase" && properties.success) {
        // Claritas
        ClaritasService.trackPurchase();

        // Facebook Ads Attribution
        if (window.fbq) {
          if (properties.isFreeTrial) {
            window.fbq("track", "StartTrial", {
              currency: properties.currency,
              value: properties.price,
            });
          } else {
            window.fbq("trackCustom", "FirstPurchase", {
              currency: properties.currency,
              value: properties.price,
            });
          }
        }

        if (window.snaptr) {
          window.snaptr("track", properties.isFreeTrial ? "ADD_CART" : "PURCHASE", {
            price: properties.price,
            currency: "USD",
            item_ids: [properties.tierKey],
            transaction_id: properties.invoiceId,
            payment_info_available: 1,
            // user_email omitted under the assumption that identify already applied it on the Snap Pixel
          });
        }

        const purchaseModel = getProductPurchaseModel(properties.tierKey);

        // Subscription
        if (purchaseModel === "subscription") {
          // Twitter Ads Attribution
          if (window.twq) {
            window.twq("event", "o7z0l", {
              value: properties.price,
              currency: "USD",
              contents: [
                {
                  content_name: properties.tierKey,
                  content_price: properties.price,
                  num_items: 1,
                },
              ],
            });
          }
        }
      }

      // Signup Success
      if (eventName === "Signup") {
        // Claritas
        ClaritasService.trackEmailCapture();
        // Facebook Ads Attribution
        if (window.fbq) {
          window.fbq(
            "track",
            "CompleteRegistration",
            {},
            { eventID: properties.external_id ? `reg_${properties.external_id}` : undefined }
          );
        }
        // Twitter Ads Attribution
        if (window.twq) {
          window.twq("event", "o7z0i");
        }
        if (window.snaptr) {
          window.snaptr("track", "SIGN_UP");
        }
      }

      // Claim Offer or Bet Now
      if (["Claim Offer", "Bet Now"].includes(eventName)) {
        // Facebook Ads Attribution
        if (window.fbq) {
          window.fbq("trackCustom", eventName, properties);
        }
        if (window.twq) {
          window.twq("event", eventName, properties);
        }
      }

      // PostHog
      capturePostHogEvent(eventName, properties);
    } catch (e: any) {
      console.error(`Error in track: ${eventName}`, e.message);
    }
  },
  page: (url: string) => {
    if (disableAnalytics) {
      console.debug("[Analytics] page", url);
      return;
    }
  },
  identify: (userId: string, userProps: any) => {
    if (userId) {
      hashString(userId.toLowerCase())
        .then((externalId) => {
          window.fbq("init", "344342939312573", {
            em: userProps.email.toLowerCase(),
            external_id: externalId,
          });

          window.snaptr("init", "54331f83-ff3b-42bb-bad6-33efc863da1b", {
            user_email: userProps.email.toLowerCase(),
            external_id: externalId,
          });
        })
        .catch((e) => {
          console.log(e.message);
        });

      // Firebase
      try {
        setUserId(analytics, userId);
      } catch (e: any) {
        console.log(e.message);
      }

      // PostHog — email is a person property, which is allowed in identify()
      identifyPostHogUser(userId, {
        email: userProps.email,
      });
    }
  },
};
